import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M22 22L15.656 15.656M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=search.js.map
